import MultilangprocessPropertiesProvider from './MultilangprocessPropertiesProvider';

const data = {
  __init__: [ 'multilangprocessPropertiesProvider' ],
  multilangprocessPropertiesProvider: [ 'type', MultilangprocessPropertiesProvider ]
};

export default data;